module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Dismiss":"Verwerfen","Delete project":"Projekt löschen","Edit":"Bearbeiten"}}')
  delete Component.options._Ctor
}
